type Params = {
  clientName: string;
  quoteNumber: number;
  index?: number | undefined;
};

const DEFAULT_REF_PREFIX = "REF";

export const generateReference = ({ clientName, quoteNumber, index }: Params) => {
  const clientPrefix = clientName.substring(0, 3).toUpperCase() || DEFAULT_REF_PREFIX;
  const nextQuoteNumber = quoteNumber + 1;
  const quoteNumberString = nextQuoteNumber.toString().padStart(6, "0");

  return `${clientPrefix}-${quoteNumberString}${
    index ? `-${index.toString().padStart(2, "0")}` : ""
  }`;
};

export const parseReference = (reference: string): Params => {
  const [clientPrefix, quoteNumber, index] = reference.split("-");
  if (!clientPrefix || !quoteNumber) {
    throw new Error("Invalid reference");
  }
  return {
    clientName: clientPrefix,
    quoteNumber: parseInt(quoteNumber, 10),
    index: index ? parseInt(index, 10) : undefined,
  };
};
